module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-d28218a7f7ed49f893088a285e2fd83b.webp";